import type * as Types from '../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { SiFieldsFragmentDoc } from '../../../graphql/gql-fragments/share-issue.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlSummaryShowQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  shareIssueId: Types.Scalars['ID']['input'];
}>;


export type GqlSummaryShowQuery = { shareIssue: { approvedByMeeting?: boolean | null, boardsStatementDate?: string | null, boardsStatementEn?: string | null, boardsStatementOption?: Types.GqlBoardsStatementOption | null, boardsStatementSv?: string | null, companyId: string, createdAt: string, description: string, id: string, maxNumberOfShares?: string | null, minNumberOfShares?: string | null, nonCashStatementPl?: string | null, nonCashStatementSl?: string | null, numberOfSharesBefore?: string | null, paidForAt?: string | null, paymentKindCash: boolean, paymentKindNonCash: boolean, paymentKindOffset: boolean, preferentialRights: boolean, pricePerShare?: string | null, maxPaidAmount?: string | null, currency: Types.GqlCurrency, primaryLang: boolean, published?: boolean | null, quotaValue?: string | null, restrictedToParticipants?: boolean | null, secondaryLang: boolean, snrAuthorizationId?: string | null, snrShareCapitalChangeId?: string | null, stripeInvoiceId?: string | null, subscriptionEndDate?: string | null, subscriptionStartDate?: string | null, updatedAt: string, purpose: Types.GqlShareIssuePurpose, decisionKind?: Types.GqlDecisionKind | null, paymentCount: { paid: number, waiting: number, notPaid: number }, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null, min: string, max: string }> } };


export const SummaryShowDocument = gql`
    query SummaryShow($companyId: ID!, $shareIssueId: ID!) {
  shareIssue(companyId: $companyId, id: $shareIssueId) {
    ...SiFields
  }
}
    ${SiFieldsFragmentDoc}`;

/**
 * __useSummaryShowQuery__
 *
 * To run a query within a React component, call `useSummaryShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryShowQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      shareIssueId: // value for 'shareIssueId'
 *   },
 * });
 */
export function useSummaryShowQuery(baseOptions: Apollo.QueryHookOptions<GqlSummaryShowQuery, GqlSummaryShowQueryVariables> & ({ variables: GqlSummaryShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlSummaryShowQuery, GqlSummaryShowQueryVariables>(SummaryShowDocument, options);
      }
export function useSummaryShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlSummaryShowQuery, GqlSummaryShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlSummaryShowQuery, GqlSummaryShowQueryVariables>(SummaryShowDocument, options);
        }
export function useSummaryShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlSummaryShowQuery, GqlSummaryShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlSummaryShowQuery, GqlSummaryShowQueryVariables>(SummaryShowDocument, options);
        }
export type SummaryShowQueryHookResult = ReturnType<typeof useSummaryShowQuery>;
export type SummaryShowLazyQueryHookResult = ReturnType<typeof useSummaryShowLazyQuery>;
export type SummaryShowSuspenseQueryHookResult = ReturnType<typeof useSummaryShowSuspenseQuery>;
export type SummaryShowQueryResult = Apollo.QueryResult<GqlSummaryShowQuery, GqlSummaryShowQueryVariables>;